import { defineStore } from 'pinia'
import axios from 'axios'

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api'

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      userId: null as number | null,
      userName: '',
      email: '',
      firstName: '',
      lastName: '',
      role: '' as string,
      memberSince: '',
      lastLoginAt: '' as string,
      pfp: null as string | null,
      is2FAEnabled: false,
      isLoading: false,
      accountBalance: 0 as number,
    }
  },

  actions: {
    async loadUserData() {
      this.isLoading = true
      try {
        // Récupérer l'utilisateur depuis localStorage
        const userStr = localStorage.getItem('user')
        if (!userStr) {
          console.error('Aucun utilisateur dans localStorage')
          return
        }

        const user = JSON.parse(userStr)
        this.userId = user.id
        this.role = user.role || ''

        // Charger les données complètes depuis l'API
        const response = await axios.get(`${apiBaseUrl}/users/${user.id}`, { withCredentials: true })

        if (response.data) {
          const userData = response.data
          this.firstName = userData.firstName || ''
          this.lastName = userData.lastName || ''
          this.userName = `${userData.firstName} ${userData.lastName}`.trim()
          this.email = userData.email || ''
          this.role = userData.role || this.role
          this.pfp = userData.photoUrl || null
          this.memberSince = userData.createdAt ? new Date(userData.createdAt).toLocaleDateString('fr-FR') : ''
          this.lastLoginAt = userData.lastLoginAt || ''

          // Récupérer le solde depuis la table user_accounts
          if (this.role !== 'Collaborateur') {
            try {
              const accountResponse = await axios.get(`${apiBaseUrl}/user-accounts/user/${user.id}`, {
                withCredentials: true,
              })
              if (accountResponse.data && accountResponse.data.data) {
                // La réponse a une structure { data: {...}, success: true }
                const accountData = accountResponse.data.data

                // Vérifier si c'est un tableau ou un objet
                if (Array.isArray(accountData) && accountData.length > 0) {
                  this.accountBalance = parseFloat(accountData[0].balance) || 0
                } else if (accountData.balance !== undefined) {
                  this.accountBalance = parseFloat(accountData.balance) || 0
                }
              }
            } catch (error) {
              console.error('Erreur lors de la récupération du compte:', error)
              this.accountBalance = 0
            }
          } else {
            this.accountBalance = 0
          }

          console.log('Données utilisateur chargées:', this.userName)
        }
      } catch (error) {
        console.error('Erreur lors du chargement des données utilisateur:', error)
      } finally {
        this.isLoading = false
      }
    },

    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },

    changeUserName(userName: string) {
      this.userName = userName
    },
  },
})
